import React, { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { Landmark, Copy } from "lucide-react";
import api from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";

export const DatiBancari = ({ op, opId }) => {
  const qc = useQueryClient();
  const [iban, setIban] = useState(op?.iban || "");
  const [banca, setBanca] = useState(op?.banca || "");
  const [saving, setSaving] = useState(false);

  const salva = async () => {
    setSaving(true);
    try {
      await api.post(`/firma/mio-account/dati-bancari?op_id=${opId}`, { iban, banca });
      qc.invalidateQueries({ queryKey: ["mio-account", opId] });
      toast.success("Dati bancari salvati");
    } catch (e) { toast.error(e.response?.data?.detail || "Errore nel salvataggio"); }
    finally { setSaving(false); }
  };

  const copiaIban = async () => {
    if (!iban) return;
    try { await navigator.clipboard.writeText(iban); toast.success("IBAN copiato"); } catch { /* ignore */ }
  };

  return (
    <div className="max-w-xl space-y-4" data-testid="dati-bancari">
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <Landmark size={16} className="text-primary" />
        Compila i tuoi dati bancari quando vuoi. Solo tu (e chi gestisce il personale) puoi vederli.
      </div>
      <div>
        <Label className="text-xs font-semibold mb-1 block">Nome della banca</Label>
        <Input value={banca} onChange={(e) => setBanca(e.target.value)} placeholder="Es. Intesa Sanpaolo" className="h-11" data-testid="banca-input" />
      </div>
      <div>
        <Label className="text-xs font-semibold mb-1 block">IBAN</Label>
        <div className="flex gap-2">
          <Input value={iban} onChange={(e) => setIban(e.target.value)} placeholder="IT00 X000 0000 0000 0000 0000 000" className="h-11 tabnum tracking-wide uppercase" data-testid="iban-input" />
          {iban && <Button type="button" variant="outline" onClick={copiaIban} className="h-11 shrink-0" title="Copia IBAN" data-testid="iban-copia"><Copy size={16} /></Button>}
        </div>
      </div>
      <Button onClick={salva} disabled={saving} className="font-semibold gr-mobile-tap" data-testid="dati-bancari-salva">{saving ? "Salvataggio..." : "Salva dati bancari"}</Button>
    </div>
  );
};
